import { BackendModule } from 'i18next';
import _ from 'lodash';

const dynamicLoadBackend: BackendModule = {
  type: 'backend' as const,
  init: function (_services, _backendOptions, _i18nextOptions) {
    // use services and options
  },
  read: async function (language, _namespace, callback) {
    // return resources
    callback(null, await lazyLoadResourcesWithRetry(language, 3));

    /* if method fails/returns an error, call this: */
    /* callback(truthyValue, null); */
  },

  // only used in backends acting as cache layer
  save: function (_language, _namespace, _data) {
    // store the translations
  },
  create: function (_languages, _namespace, _key, _fallbackValue) {
    // save the missing translation
  },
};

export default dynamicLoadBackend;

/**
 * Attempts to dynamically import the desired language pack with the given
 * number of retries. Returns undefined if all retries fail.
 */
async function lazyLoadResourcesWithRetry(
  lng: string,
  maxRetries: number,
  currRetry = 0,
): Promise<string | undefined> {
  try {
    const translation = await import(`locales/translation.${lng}.json`);

    // Dynamically imported JSON is returned as ESM by vite. We have to access `.default` for the full data.
    const resourceBundle = translation.default || translation;

    if (resourceBundle == null) {
      throw new Error('Failed to dynamic import resource bundle');
    }

    return _.cloneDeep({ ...resourceBundle });
  } catch (err) {
    return currRetry === maxRetries
      ? undefined
      : new Promise((resolve) =>
          setTimeout(
            () => resolve(lazyLoadResourcesWithRetry(lng, maxRetries, currRetry + 1)),
            500 * (currRetry + 1),
          ),
        );
  }
}
